import * as React from 'react';

function SvgFootballTab(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={30} {...props}>
      <defs>
        <style>{`.football_tab_svg__prefix__cls-2{fill:${props.fill}`}</style>
      </defs>
      <g id="football_tab_svg__prefix__football_tab" transform="translate(-210 -97)">
        <path
          id="football_tab_svg__prefix__Rectangle_2037"
          d="M0 0h40v30H0z"
          data-name="Rectangle 2037"
          transform="translate(210 97)"
          fill="none"
        />
        <g id="football_tab_svg__prefix__football" transform="translate(215 97)">
          <path
            id="football_tab_svg__prefix__Path_5461"
            d="M49.458 17.305a11.467 11.467 0 001.473-4.425v-.015a11.635 11.635 0 00.078-1.34 11.5 11.5 0 00-3.015-7.775.589.589 0 00-.1-.113A11.525 11.525 0 0043.463.7a.578.578 0 00-.095-.034 11.46 11.46 0 00-8.113.157.587.587 0 00-.1.043 11.543 11.543 0 00-4.209 3 .608.608 0 00-.1.112 11.5 11.5 0 00-2.818 7.552 11.615 11.615 0 00.071 1.28v.015a11.461 11.461 0 00.472 2.214L22.4 21.226a.589.589 0 10.831.834l5.8-5.82a11.5 11.5 0 00.537 1.049.582.582 0 00.067.114 11.551 11.551 0 006.575 5.16l-4.14 4.152a.59.59 0 00.416 1.006.585.585 0 00.416-.173l4.654-4.667a11.47 11.47 0 0011.827-5.452.587.587 0 00.073-.124zm-5.085.023L42.282 14.1l1.112-3.432 2.643-.6.688-.155 3 3.094a10.287 10.287 0 01-1.191 3.53zM36.756 14.1l-2.09 3.225-4.178-.8a10.291 10.291 0 01-1.188-3.563l3.01-3.043 3.334.751.741 2.287zm-5.792-8.353l.53 3.323-2.294 2.317a10.307 10.307 0 011.761-5.64zm6.864 7.85l-1.038-3.2 2.718-1.98 2.718 1.98-1.038 3.2zm12.006-2.164l-2.3-2.371.407-3.51a10.31 10.31 0 011.893 5.882zM46.9 4.3l-.52 4.485-1.264.285-2.047.461-2.951-2.15V4.194L43.307 1.9A10.352 10.352 0 0146.9 4.3zm-5-2.846l-2.406 1.737-2.688-1.649a10.3 10.3 0 015.1-.084zm-6.525.59l3.54 2.172v3.168L36.838 8.9l-.869.634-3.33-.75-.684-4.284a10.363 10.363 0 013.425-2.451zM31.4 17.9l3.171.611 1.615 2.807A10.36 10.36 0 0131.4 17.9zm6.377 3.825L35.632 18l2.088-3.223h3.6L43.405 18l-2.142 3.724a10.316 10.316 0 01-3.49 0zm5.08-.407l1.614-2.806 3.159-.6a10.358 10.358 0 01-4.773 3.4zm0 0"
            className="football_tab_svg__prefix__cls-2"
            data-name="Path 5461"
            transform="translate(-21.01)"
          />
          <path
            id="football_tab_svg__prefix__Path_5462"
            d="M7.532 357.366l-7.371 7.372a.547.547 0 10.773.773l7.372-7.372a.547.547 0 00-.774-.774zm0 0"
            className="football_tab_svg__prefix__cls-2"
            data-name="Path 5462"
            transform="translate(0 -335.672)"
          />
          <path
            id="football_tab_svg__prefix__Path_5463"
            d="M156.695 481.012a.547.547 0 10.387.16.551.551 0 00-.387-.16zm0 0"
            className="football_tab_svg__prefix__cls-2"
            data-name="Path 5463"
            transform="translate(-146.974 -452.707)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgFootballTab;
